import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Location from "./sections/Location";
import Construction from "./sections/Construction";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Contact />
      <Location />
      <Construction />
      <Footer />
    </div>;
}